module.exports = __webpack_public_path__ + "static/media/py.e8997865.png";